<template>
    <v-container class="noMargin">
        <v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_USER') !== -1">
            <v-flex lg12>
				<div class="pageTitle">
                  <h2>
                    <!--<v-menu offset-y>
                      <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                      <v-list>
                        <v-list-tile>
                          <v-list-tile-title>
                            <a @click.prevent="fncGoUser('reps')">{{ this.objAuthorize.manu_user_alias }}</a>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-title>
                            <a @click.prevent="fncGoUser('customer-users')">{{ this.objAuthorize.customer_user_alias }}</a>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-title>
                            <a @click.prevent="fncGoUser('specific-users')">{{ this.objAuthorize.specifier_user_alias }}</a>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-title>
                            <a @click.prevent="fncGoUser('public-users')">{{ this.objAuthorize.public_user_alias }}</a>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile v-if="objAuthorize.privileges.indexOf('VENDOR_MODULE') !== -1">
                          <v-list-tile-title>
                            <a @click.prevent="fncGoUser('vendor-users')">Vendor Users</a>
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>-->
                    {{ fncUserHeader() }}
                  </h2>
				</div>
              <img style="margin-right: 20px;margin-top: 4px;" v-if="userLoading == true" src="../../shared/assets/images/ajax.gif" />
                <v-btn @click.prevent="fncCreateCompany" v-if="userType == 'customer-users'" class="elevation-5" color="info"><i class="material-icons">add</i>Create Company</v-btn>
                <v-btn @click.prevent="fncCreateUser" v-if="userLoading == false" class="elevation-5" color="info"><i class="material-icons">add</i>Create User</v-btn>
              <v-menu offset-y>
                <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                <v-list>
                  <v-list-tile @click.prevent="fncImportBranches">
                    <v-list-tile-title>
                      <a>Import Branches</a>
                    </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click.prevent="fncImportCompanies">
                        <v-list-tile-title>
                            <a>Import Companies</a>
                        </v-list-tile-title>
                    </v-list-tile>
                  <v-list-tile @click.prevent="fncImportUsers">
                    <v-list-tile-title>
                      <a>Import Users</a>
                    </v-list-tile-title>
                    </v-list-tile>
                  <v-list-tile @click.prevent="fncUserSettings">
                    <v-list-tile-title>
                      <a>User Settings</a>
                    </v-list-tile-title>
                    </v-list-tile>
                  <v-list-tile @click.prevent="fncOverrideSettings">
                    <v-list-tile-title>
                      <a>Doc Override Settings</a>
                      <!--<a v-if="objAuthorize.privileges.indexOf('USER_OVERRIDE_SETTINGS') !== -1" @click.prevent="fncOverrideSettings">Doc Override Settings</a>-->
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click.prevent="fncExportUsers">
                    <v-list-tile-title>
                      <a>Export Users</a>
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    import { mapGetters } from 'vuex';
    import router from '@/router';

    export default {
        name: 'UserHeader',
        data () {
            return {
                userType: ''
            }
        },
        methods: {
            fncUserHeader() {
              var objUser = window.location.href.split('/');
              var pageTitle = objUser[objUser.length - 1];
              this.userType = pageTitle;
                  //pageTitle = pageTitle.replace('-', ' ');
                switch (pageTitle){
                  case 'reps':
                    return this.objAuthorize.manu_user_alias;
                  case 'customer-users':
                    return this.objAuthorize.customer_user_alias;
                  case 'specific-users':
                    return this.objAuthorize.specifier_user_alias;
                  case 'public-users':
                    return this.objAuthorize.public_user_alias;
                  case 'vendor-users':
                    return 'Vendor Users';
                  default:
                    return pageTitle
                }
            },
            fncCreateCompany() {
              this.$store.dispatch('fncPopulateUserRegions');
              this.$store.dispatch('fncSetupUserCreate', 'company');
            },
            fncCreateUser() {
              this.$store.commit('fncSetUserLoading', true);
              this.$store.dispatch('fncPopulateUserRegions');
              this.$store.dispatch('fncPopulateUserVendors');
              this.$store.dispatch('fncSetupUserCreate', 'user');
                var modalDetails = { title: 'Create User', component: 'modal-user-create', mstate: true, params: {} };
                this.$store.commit({
                    type: 'setModal',
                    details: modalDetails
                });
            },
            fncUserSettings() {
              if (this.objUserSettings == '' ) {
                this.$store.commit('setObjUserSettings', this.objAuthorize);
              } else {
                this.$store.commit({
                  type: 'setObjUserSettings',
                  manu_user_alias: this.objUserSettings.manufacturerAlias,
                  manu_user_clr: this.objUserSettings.manufacturerColor,
                  customer_user_alias: this.objUserSettings.customerAlias,
                  customer_user_clr: this.objUserSettings.customerColor,
                  specifier_user_alias: this.objUserSettings.specificAlias,
                  specifier_user_clr: this.objUserSettings.specificColor,
                  public_user_alias: this.objUserSettings.publicAlias,
                  public_user_clr: this.objUserSettings.publicColor
                })
                var objAlias = {
                  manu_user_alias: this.objUserSettings.manufacturerAlias,
                  manu_user_clr: this.objUserSettings.manufacturerColor,
                  customer_user_alias: this.objUserSettings.customerAlias,
                  customer_user_clr: this.objUserSettings.customerColor,
                  specifier_user_alias: this.objUserSettings.specificAlias,
                  specifier_user_clr: this.objUserSettings.specificColor,
                  public_user_alias: this.objUserSettings.publicAlias,
                  public_user_clr: this.objUserSettings.publicColor
                }
                this.$store.commit('fncUpdateObjAuth', objAlias, { root: true });
              }
                var modalDetails = { title: 'User Settings', component: 'modal-user-settings', mstate: true, params: {} };
                this.$store.commit({
                    type: 'setModal',
                    details: modalDetails
                });
            },
            fncImportUsers() {
                var modalDetails = { title: 'Import Users', component: 'modal-user-import', mstate: true, params: {} };
                this.$store.commit({
                    type: 'setModal',
                    details: modalDetails
                });
            },
            fncImportBranches() {
                var modalDetails = { title: 'Import Branches', component: 'modal-branch-import', mstate: true, params: {} };
                this.$store.commit({
                    type: 'setModal',
                    details: modalDetails
                });
            },
            fncImportCompanies() {
                var modalDetails = { title: 'Import Companies', component: 'modal-company-import', mstate: true, params: {} };
                this.$store.commit({
                    type: 'setModal',
                    details: modalDetails
                });
            },
            fncOverrideSettings() {
              this.$store.dispatch('fncOverrideSettings');
            },
            fncExportUsers() {

              this.$store.dispatch('fncExportRepToExcel');

            },
            fncReloadUsers() {
              var objUser = window.location.href.split('/');
              var pageTitle = objUser[objUser.length - 1];
              var context = 0;
              if (pageTitle == 'reps') {
                context = 1;
              } else if (pageTitle == 'customer-users' ) {
                context = 2;
              } else if (pageTitle == 'specific-users') {
                context = 3;
              } else if (pageTitle == 'public-users') {
                context = 4;
              }
              this.$store.commit('fncEmptyUsers', context);
              this.$store.dispatch({
                type: 'fncPopulateUsers',
                context: context
              });
            },
            fncGoUser(url) {
              router.replace('/users/'+url);
            }
        },
        computed: {
            ...mapGetters([
            'objAuthorize',
            'objUserSettings',
            'userLoading'
            ])
        }
    }
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>
